<template>
    <div>
        <van-nav-bar
            title="投诉建议"
            left-text="返回"
            left-arrow
            @click-left="clickback"
            @click-right="create"
        >
        <template #right>
            <van-icon name="plus" size="18" />
        </template>
        </van-nav-bar>
        <van-loading vertical v-if="loading"/>
        <van-cell center  size="large" v-for="item in dataList" :key="item.id" :title="item.shop_name" >
            <template slot="label" >
                <span style="display:block;">{{"投诉时间："}}{{item.complaint_date  | moment("YYYY-MM-DD HH:mm")}}</span>
                <span style="display:block;">{{"投诉建议："}}{{item.content}}</span>
            </template>
            <template slot="default" >
                <span v-if="item.state" style="display:block;color:blue;">{{item.status}}</span>
                <span v-else style="display:block;color:red;">{{item.status}}</span>
            </template>
        </van-cell>
    </div>
</template>

<script>
import { NavBar, Icon, Cell, Loading } from 'vant';
import { ComplaintApi } from '@/api/vip'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Icon.name]: Icon,
        [Cell.name]: Cell,
        [Loading.name]: Loading
    },
    data() {
        return {
            dataList: [],
            loading: true
        }
    },
    mounted(){
        this.getComplaint()
    },
    methods: {
        getComplaint(){
            var that = this
            that.axios.get(ComplaintApi).then((ret) => {
                this.loading = false
               that.dataList = ret
            })
        },
        create(){
            this.$router.push(`/nt/user/complaintcreate`)
        },
        clickback() {
            try {
                this.$router.go(-1)
            } catch {
                this.$router.push(`/nt/user/membercentre`)
            }
        }
    }
}
</script>

<style lang="less" scoped>
</style>